import type {
  DeviceMediaItem,
  DevicePlaylist,
  DeviceSync,
} from "@workspace/api-client-react";
import {
  buildRotation,
  playlistById,
} from "@workspace/player-core";
import type { TimedEventFire } from "@/player/lib/scheduling/types";

/** Locate a single media asset across hydrated playlists in the sync payload. */
export function mediaAssetById(
  sync: DeviceSync | null,
  mediaAssetId: string | null | undefined,
): DeviceMediaItem | null {
  if (!sync || !mediaAssetId) return null;
  for (const playlist of sync.playlists) {
    const found = playlist.items.find((item) => item.id === mediaAssetId);
    if (found) return found;
  }
  return null;
}

/** Resolve playable items for a timed event's content reference. */
export function resolveTimedEventItems(
  sync: DeviceSync | null,
  event: TimedEventFire,
): DeviceMediaItem[] {
  if (!sync) return [];

  if (event.contentType === "playlist" && event.playlistId) {
    const playlist = playlistById(sync, event.playlistId);
    return playlist ? buildRotation(playlist) : [];
  }

  if (event.contentType === "media" && event.mediaAssetId) {
    const item = mediaAssetById(sync, event.mediaAssetId);
    return item ? [item] : [];
  }

  return [];
}

export function resolveBoundaryPlaylist(
  sync: DeviceSync | null,
  boundaryPlaylistId: string | null | undefined,
): DevicePlaylist | null {
  return playlistById(sync, boundaryPlaylistId);
}
